export const PERSON_GENDER_MALE = 'male';
export const PERSON_GENDER_FEMALE = 'female';
export const PERSON_GENDER_DIVERSE = 'diverse';
export const PERSON_GENDER_NOT_SPECIFIED = 'not_specified';

export const PERSON_TITLE_DOCTOR = 'doctor';
export const PERSON_TITLE_PROFESSOR = 'professor';
export const PERSON_TITLE_PROFESSOR_WITH_PROMOTION = 'professor_with_promotion';

export const CONTRIBUTION_INTERVIEWEE = 'interviewee';
